module.exports = __webpack_public_path__ + "img/banner-32.ee83ec3d.jpg";